import {request} from '@/plugins/axios'
import qs from 'qs';
//get=>params  post=>data
//获取国家列表
export async function getCountry(opt) {
    return await request({
        url: '/api/com/country',
        method: 'get',
        params: opt
    })
}

//获取城市列表
   export async function getArea(opt) {
    return await request({
        url: '/api/com/area',
        method: 'get',
        params: opt
        /* data:opt */
    })
}

//产品分类 

export async function getCategoryList(opt) {
    return await request({
        url: '/api/u_p/category',
        method: 'get',
        params: opt
       /*  data:opt */
    })
}

//确定下单

export async function submitForm(opt) {
	//mydev
	var url="/api/u_p/add";
	if(opt.user_id!=undefined){
		   
	}
    return await request({
        url: url,
        method: 'post',
        /* params: opt */
        data:qs.stringify(opt)
    })
}

//获取个人信息
export async function getMyInfo(opt) {
    return await request({
        url: '/api/u_p/user',
        method: 'get',
        params: opt,
       /* data:opt, */
    })
}

//地区联动 列表
export async function getAddressList(opt) {
    return await request({
        url: '/api/com/country_city',
        method: 'get',
        params: opt
      /*  data:opt, */
       
    })
}


//获取下单表单信息
export async function getCurrentFullInfo(opt) {
    return await request({
        url: '/api/u_q/details',
        method: 'get',
        params: opt,
       /* data:opt, */
       
    })
}


//获取工厂地址薄列表
export async function getFactoryAddressList(opt) {
    return await request({
        url: '/api/a_u/company_list',
        method: 'post',
        /* params: opt */
        data:opt
    })
}


//工厂地址添加 
export async function addFacatoryAddress(opt) {
    return await request({
        url: '/api/a_u/addr',
        method: 'post',
        /* params: opt */
        data:opt,
    })
}
//工厂地址编辑
export async function addFacatoryEditress(opt) {
    return await request({
        url: '/api/a_u/edit_company',
        method: 'post',
        /* params: opt */
        data:opt,
    })
}


//工厂删除
export async function FacatoryDelAddress(opt) {
    return await request({
        url: '/api/a_u/del_company',
        method: 'post',
        /* params: opt */
        data:opt,
    })
}

//调高德地址模糊搜索
export async function addressSearchFromGaode(opt) {
    return await request({
        url: '/api/com/search_detail',
        method: 'get',
        params:opt 
    })
}

// 调用百度地图模糊查询
export async function addressSearchFromMap(opt) {
    return await request({
        url: '/api/h_i/getPlace',
        method: 'get',
        params:opt 
    })
}
// 返单列表
export async function backOrderList(opt) {
    return await request({
        url: '/api/u_q/r_list',
        method: 'get',
        params:opt 
    })
}
// 返单详情
export async function backOrderDetail(opt) {
    return await request({
        url: '/api/u_q/r_details',
        method: 'get',
        params:opt 
    })
}
// 确认订单
export async function confirmOrder(opt) {
    return await request({
        url: '/api/u_pay/confirm_order',
        method: 'get',
        params:opt 
    })
}
// 提交付款
export async function submit(opt) {
    return await request({
        url: '/api/u_pay/submit',
        method: 'post',
        data:opt 
    })
}
// 确认付款信息
export async function confirm_info(opt) {
    return await request({
        url: '/api/u_pay/confirm_info',
        method: 'post',
        data:opt 
    })
}
// 额外费用确认付款
export async function increase_cost(opt) {
    return await request({
        url: '/api/u_o/increase_cost',
        method: 'get',
        params:opt 
    })
}
// 确认付款
export async function confirm(opt) {
    return await request({
        url: '/api/u_pay/confirm',
        method: 'get',
        params:opt
    })
}

export async function confirmIncrease(opt) {
    return await request({
        url: '/api/u_pay/increase',
        method: 'post',
        params:opt
    })
}

// 优惠券接口
export async function coupon(opt) {
    return await request({
        url: '/api/u_pay/coupon',
        method: 'get',
        params:opt 
    })
}
export async function getYaoqingCode(params) {
    return await request({
        url: '/api/u_e/code',
        method: 'get',
        params:params
    })
}
// 验货类价格获取
export async function getInspection(params) {
    return await request({
        url: '/api/u_h/Inspection',
        method: 'get',
        params:params
    })
}

export async function judge(params) {
    return await request({
        url: '/api/u_h/judge',
        method: 'post',
        data:params
    })
}


export async function getConmentListApi(params) {
    return await request({
        url: '/api/u_o/history_record',
        method: 'get',
        params:params
    })
}

export async function recognize(params) {
    return await request({
        url: '/api/u_o/recognize',
        method: 'post',
        data:params
    })
}
// AI识别
// export async function ai_recognize(params) {
//     return await request({
//         url: '/api/u_o/ai_recognize',
//         method: 'post',
//         data:params
//     })
// }
export async function ai_resolve_order(params) {
    return await request({
        url: '/api/u_o/ai_resolve_order',
        method: 'post',
        data:params
    })
}